import React, { useState } from "react";
import "./Request.css";

export default function Request() {
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleReplyClick = () => {
    setShowReplyForm(true);
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);

    // Check file sizes
    const oversizedFiles = files.filter((file) => file.size > 10 * 1024 * 1024); // 10MB in bytes

    if (oversizedFiles.length > 0) {
      setErrorMessage(
        "One or more files exceed the 10MB size limit. Please choose smaller files."
      );
      setShowErrorPopup(true);
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const removeFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Check if any files are over 10MB (double check)
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > 10 * 1024 * 1024
    );
    if (oversizedFiles.length > 0) {
      setErrorMessage(
        "One or more files exceed the 10MB size limit. Please remove them before submitting."
      );
      setShowErrorPopup(true);
      return;
    }

    // Simulate form submission
    console.log("Form submitted successfully");

    // Show success popup
    setShowSuccessPopup(true);

    // Reset form after a delay
    setTimeout(() => {
      // Reset form state
      setShowReplyForm(false);
      setSelectedFiles([]);
      setShowSuccessPopup(false);

      // Reset form fields
      event.target.reset();
    }, 2000);
  };

  const closeSuccessPopup = () => {
    setShowSuccessPopup(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <div className="request-page">
      {/* Header Section - Outside the white container */}
      <div className="request-header">
        <h1>Admin's Request</h1>
        <p className="subtitle">Click and respond to the message</p>
      </div>

      <div className="request-divider"></div>

      {/* White Container for Request Details */}
      <div className="request-container">
        <div className="request-details">
          <div className="request-title-section">
            <h2 className="request-title">Volunteer Recognition Event</h2>
            <span className="request-date">Sun, Mar 10, 2024</span>
          </div>

          <div className="request-content">
            <p>
              Join us for our monthly member meeting on Saturday, March 16th at
              2:00 PM.
              <br />
              We'll be discussing important policy updates and upcoming
              initiatives.
            </p>
          </div>

          <p className="reply-btn" onClick={handleReplyClick}>
            Reply
          </p>
        </div>

        {/* Reply Form Section - Only shows when Reply is clicked */}
        {showReplyForm && (
          <div className="reply-form-section">
            <div className="form-divider"></div>

            <form className="reply-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="subject" className="form-label">
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  className="form-input"
                  placeholder="Enter subject"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message *
                </label>
                <textarea
                  id="message"
                  className="form-textarea"
                  placeholder="Enter your message"
                  rows="6"
                  required
                ></textarea>
              </div>

              <div className="form-group">
                <label className="form-label">Attachments (Optional)</label>
                <p className="attachment-note">
                  Upload photo or video from the activity (max 10MB per file)
                </p>
              </div>

              <div className="form-divider"></div>

              <div className="photo-upload-section">
                <h3 className="photo-title">Choose Photo/Video</h3>

                {/* File Upload Area */}
                <div className="upload-area">
                  <input
                    type="file"
                    id="file-upload"
                    multiple
                    accept="image/*,video/*"
                    onChange={handleFileUpload}
                    className="file-input"
                  />
                  <label htmlFor="file-upload" className="upload-label">
                    <span className="upload-icon">+</span>
                    <span className="upload-text">Add files</span>
                  </label>
                </div>

                {/* Selected Files Preview */}
                {selectedFiles.length > 0 && (
                  <div className="selected-files">
                    <h4>Selected Files:</h4>
                    <div className="files-list">
                      {selectedFiles.map((file, index) => (
                        <div key={index} className="file-item">
                          <span className="file-name">
                            {file.name}
                            <span className="file-size">
                              ({(file.size / (1024 * 1024)).toFixed(2)} MB)
                            </span>
                          </span>
                          <button
                            type="button"
                            className="remove-file"
                            onClick={() => removeFile(index)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <div className="form-submit-section">
                <button type="submit" className="submit-btn">
                  Submit Response
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup success-popup">
            <div className="popup-icon">✓</div>
            <h3>Success!</h3>
            <p>Your response has been submitted successfully.</p>
            <button className="popup-close-btn" onClick={closeSuccessPopup}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {showErrorPopup && (
        <div className="popup-overlay">
          <div className="popup error-popup">
            <div className="popup-icon">⚠</div>
            <h3>File Size Error</h3>
            <p>{errorMessage}</p>
            <button className="popup-close-btn" onClick={closeErrorPopup}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
